module.exports = __webpack_public_path__ + "img/List Icon - white.22a4587e.svg";